module.exports = __webpack_public_path__ + "img/Interest-sailing--active.39c53f28.svg";